const TYPE_AND_READ_AS_MAPPER = {
  buffer: 'readAsArrayBuffer',
  data: 'readAsDataURL',
  text: 'readAsText',
} as const;

const _readAs =
  <
    T extends 'data' | 'buffer' | 'text',
    R extends T extends 'buffer' ? ArrayBuffer : string,
  >(
    type: T,
  ) =>
  (blob: Blob) =>
    new Promise<R>((resolve, reject) => {
      const fr = new FileReader();

      fr.onloadend = ev => {
        const target = ev.target;

        if (target) {
          resolve(target.result as R);
        } else {
          reject(new Error('Target wrong'));
        }
      };

      fr[TYPE_AND_READ_AS_MAPPER[type]](blob);
    });

export const readAsBuffer = _readAs('buffer');
export const readAsData = _readAs('data');
export const readAsText = _readAs('text');
